module.exports = __webpack_public_path__ + "static/exponential-growth-e286df97ebec8ca4686b00815a5c03e4.svg";